import type { ReactNode } from "react"

import { BrandSwitchSplash } from "@/components/brand-switch-splash"
import { CurrentContextProvider } from "@/components/current-context-provider"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"

interface PersistentLayoutProps {
  children: ReactNode
}

/**
 * PersistentLayout — survives Inertia visits.
 *
 * Wraps every page with:
 *   - `<CurrentContextProvider>` so `useCurrentContext()` works anywhere,
 *      including pages that don't mount `<AppLayout>` (auth pages, onboarding).
 *   - flash-toast bridge + sonner Toaster for global feedback.
 */
export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <CurrentContextProvider>
      {children}
      {/* OKS-701 — global one-shot brand-switch arrival splash. Mounted
          here (not in a shell) so it plays on BOTH possible switch
          destinations: the creator shell (missions home) and the wizard
          shell (onboarding, for incomplete memberships). Renders null
          unless a `brand_switch_splash` flash just arrived. */}
      <BrandSwitchSplash />
      <Toaster richColors />
    </CurrentContextProvider>
  )
}
